var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIconBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7956 2.20436C21.9852 2.39388 22.0494 2.6752 21.9608 2.92817L15.4492 21.5328C15.3547 21.8028 15.1049 21.9878 14.8191 21.9994C14.5333 22.0111 14.2693 21.8471 14.1531 21.5857L10.5412 13.4588L2.41433 9.84686C2.15292 9.73068 1.98892 9.4667 2.00058 9.18087C2.01224 8.89505 2.1972 8.64531 2.4672 8.55081L21.0718 2.03919C21.3248 1.95065 21.6061 2.01485 21.7956 2.20436ZM11.9019 13.0848L14.7135 19.4109L19.6338 5.35282L11.9019 13.0848ZM18.6472 4.36616L4.58912 9.28648L10.9152 12.0981L18.6472 4.36616Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIconBlack);
export default __webpack_public_path__ + "static/media/send-icon-black.3e3c902ccbf834a3926a4b88146fa8a6.svg";
export { ForwardRef as ReactComponent };